import React, { useReducer } from 'react'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import { luxAwardInitialState, LuxAwardModalDispatchContext, LuxAwardModalStateContext, luxAwardModalStateReducer } from './LuxAwardModalContexts'
import LuxAwardModalStepHome from './LuxAwardModalStepHome'
import { PRIZES } from './luxAwardPrizes'
import LuxAwardModalStepPrize from './LuxAwardModalStepPrize'
function LuxAwardModal() {
  const [state, dispatch] = useReducer(luxAwardModalStateReducer, luxAwardInitialState)

  return <ModalBase size="L" onAfterClose={() => {

  }}>
    <LuxAwardModalStateContext.Provider value={state}>
      <LuxAwardModalDispatchContext.Provider value={dispatch}>
        {state.currentStep === 'home' && <LuxAwardModalStepHome />}
        {PRIZES.map(prize => (state.currentStep === prize.key) && <LuxAwardModalStepPrize key={prize.key} prizeKey={prize.key} />)}
      </LuxAwardModalDispatchContext.Provider>
    </LuxAwardModalStateContext.Provider>
  </ModalBase>
}

export default LuxAwardModal
